module.exports = __webpack_public_path__ + "img/do_not_disturb_off.03330bc1.svg";